// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__sXhET","modalForm":"UpgradeEpcsModal_modalForm__soTjQ","modalFooter":"UpgradeEpcsModal_modalFooter__2kT_C"};